import { useQuery } from 'react-query';

import { FEATURE_DATA } from '../../constants/endpoints';
import api from '../../utils/api';

const fetchFreeTrialPeriod = () => api.get(`${FEATURE_DATA}/trial-period`);
export const useFetchFreeTrialPeriod = () =>
  useQuery([FEATURE_DATA], async () => {
    const data = await fetchFreeTrialPeriod();
    const freeTrialPeriod = parseInt(data?.trialPeriodDays);

    return isNaN(freeTrialPeriod) ? 7 : freeTrialPeriod;
  });



// WEBPACK FOOTER //
// ./src/hooks/react-query/useFeatureData.js